import { StatusKey } from '../../../types/daily-updates';
import { LinearProgress, Box, Card, Typography, Paper } from '@mui/material';
import { alpha } from '@mui/material';
import { styled } from '@mui/material/styles';

export const COLORS = {
	primary: '#3a36e0',
	primaryLight: '#5151ff',
	secondary: '#6c5ce7',
	secondaryLight: '#a29bfe',
	success: '#00b894',
	warning: '#fdcb6e',
	error: '#ff7675',
	neutral: '#f7f9fc',
	neutralDark: '#dfe6e9',
	text: '#2d3436',
	textLight: '#636e72',
	white: '#ffffff',
	cardBg: '#ffffff',
	tableBg: '#f8fafc'
};

export const STATUS_COLORS: Record<StatusKey, string> = {
	dismissed: COLORS.error,
	completed: COLORS.success,
	inProgress: COLORS.primary,
	pending: COLORS.warning
};

export const ModernCard = styled(Card)({
	borderRadius: '16px',
	overflow: 'hidden',
	boxShadow: '0 10px 30px rgba(0, 0, 0, 0.05)',
	border: `1px solid ${COLORS.neutralDark}`,
	transition: 'transform 0.3s ease, box-shadow 0.3s ease',
	background: `linear-gradient(145deg, ${COLORS.cardBg} 0%, ${alpha(COLORS.neutralDark, 0.1)} 100%)`,
	'&:hover': {
		transform: 'translateY(-5px)',
		boxShadow: '0 15px 35px rgba(0, 0, 0, 0.1)'
	}
});

export const CardHeader = styled(Box)({
	padding: '16px 24px',
	borderBottom: `1px solid ${alpha(COLORS.neutralDark, 0.5)}`,
	background: COLORS.neutral
});

export const ProgressContainer = styled(Box)({
	width: '100%',
	marginTop: '8px',
	marginBottom: '4px'
});

export const ModernProgress = styled(LinearProgress)(({ barColor }: { barColor: string }) => ({
	height: 8,
	borderRadius: 4,
	backgroundColor: alpha(barColor, 0.15),
	'& .MuiLinearProgress-bar': {
		borderRadius: 4,
		backgroundColor: barColor
	}
}));

// Style for status tiles
export const StatusTile = styled(Paper)(({ color }: { color: string }) => ({
	padding: '20px',
	borderRadius: '16px',
	background: COLORS.white,
	boxShadow: '0 8px 25px rgba(0, 0, 0, 0.05)',
	borderLeft: `4px solid ${color}`,
	display: 'flex',
	flexDirection: 'column',
	transition: 'transform 0.2s ease, box-shadow 0.2s ease',
	'&:hover': {
		transform: 'translateY(-4px)',
		boxShadow: '0 12px 30px rgba(0, 0, 0, 0.1)'
	}
}));

export const StatusCount = styled(Typography)({
	fontSize: '32px',
	fontWeight: 700,
	marginBottom: '8px',
	color: COLORS.text
});

export const TimestampText = styled(Typography)({
	fontSize: '13px',
	color: COLORS.textLight,
	display: 'flex',
	alignItems: 'center',
	gap: '6px'
});

export const keyMapping = {
	completed: 'Completed',
	inProgress: 'In Progress',
	pending: 'Pending',
	dismissed: 'Dismissed'
};
